import {
  Component,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { TenantService, TenantInfo } from '../shared/services/tenant.service';

@Component({
  selector: 'black-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css'],
  standalone: false,
})
export class PrivacyComponent implements OnInit, OnDestroy {
  private tenantService = inject(TenantService);
  private platformId = inject(PLATFORM_ID);

  private sub?: Subscription;

  currentTenant: TenantInfo | null = null;
  mode: 'default' | 'link' | 'custom' = 'default';
  externalUrl?: string;
  customContent?: string;
  lastUpdated?: string | Date;

  ngOnInit(): void {
    this.sub = this.tenantService.currentTenant$.subscribe((tenant) => {
      this.currentTenant = tenant;
      const policies = tenant?.settings?.policies;
      this.mode = policies?.privacyMode || 'default';
      this.externalUrl = policies?.privacyUrl;
      this.customContent = policies?.privacyContent;
      this.lastUpdated = policies?.privacyUpdatedAt;

      if (this.mode === 'link' && this.externalUrl) {
        if (isPlatformBrowser(this.platformId)) {
          window.location.replace(this.externalUrl);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get academyName(): string {
    return this.currentTenant?.name || 'Learnbird';
  }

  get contactEmail(): string {
    return (
      this.currentTenant?.settings?.legal?.contactEmail ||
      'privacy@learnbird.lk'
    );
  }
}
